import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgxChartsModule } from '@swimlane/ngx-charts';

export interface PieChartData {
  name: string;
  value: number;
}

export interface UniversityData {
  name: string;
  [key: string]: any;
}

@Component({
  selector: 'app-pie',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.scss'],
  imports: [CommonModule, MatIconModule, NgxChartsModule]
})
export class PieComponent implements OnInit {
  @Input() tabName: string = '';
  @Input() universitiesData: UniversityData[] = [];
  @Input() metrics: string[] = [];
  @Input() chartSize: [number, number] = [250, 250];
  @Input() showAnimations: boolean = false;
  @Input() colorScheme: string = 'vivid';
  
  @Output() pieChartSelect = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    // Component initialization
  }

  /**
   * Get pie chart data for a specific university and metric
   */
  getPieChartData(university: UniversityData, metric: string): PieChartData[] {
    const value = university[metric] || 0;
    const remaining = 100 - value;
    
    return [
      { name: metric, value: value },
      { name: 'Remaining', value: remaining }
    ];
  }

  /**
   * Handle pie chart selection
   */
  onPieChartSelect(event: any): void {
    this.pieChartSelect.emit(event);
  }

  /**
   * Get the score value for display
   */
  getScoreValue(university: UniversityData, metric: string): number {
    return university[metric] || 0;
  }

  /**
   * Get the score label based on tab name
   */
  getScoreLabel(): string {
        return 'Score';
  }

  /**
   * Get the section title based on tab name
   */
  getSectionTitle(): string {
    switch (this.tabName.toLowerCase()) {
      case 'course comparison':
        return 'ROI Comparison - Pie Charts';
      case 'key influence sources':
        return 'Influence Comparison - Pie Charts';
      case 'performance tracking':
        return 'Performance Comparison - Pie Charts';
      default:
        return 'Comparison - Pie Charts';
    }
  }

  /**
   * Get the icon based on tab name
   */
  getSectionIcon(): string {
    switch (this.tabName.toLowerCase()) {
      case 'course comparison':
        return 'trending_up';
      case 'key influence sources':
        return 'influence';
      case 'performance tracking':
        return 'pie_chart';
      default:
        return 'pie_chart';
    }
  }
}
